'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import type { FC } from 'react';
import { useUserStore } from '@/entities/User/store/userStoreProvider';
import { cn } from '@/libs/utils';
import { FastNavLink } from '@/shared/components/FastNavLink';
export const Navigation: FC<{
  mobileMenuVisible: boolean;
  onNavigate?: (path: string) => void;
  setIsMobileMenuOpen?: (open: boolean) => void;
}> = t0 => {
  const $ = _c(23);
  const {
    mobileMenuVisible,
    setIsMobileMenuOpen
  } = t0;
  const t = useTranslations("HeaderV2.Navigation");
  const pathname = usePathname();
  const user = useUserStore(_temp);
  const locale = useLocale();
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== locale || $[1] !== mobileMenuVisible || $[2] !== pathname || $[3] !== setIsMobileMenuOpen || $[4] !== t || $[5] !== user?.id) {
    const navItems = [{
      key: "market",
      label: t("Market"),
      path: "/auctions/"
    }, {
      key: "actions",
      label: t("Actions"),
      path: "/earn/"
    }, {
      key: "leaderboard",
      label: t("Leaderboard"),
      path: "/leaderboard/"
    }, {
      key: "partners",
      label: t("Partners"),
      path: "/partners/"
    }, {
      key: "my-account",
      label: t("MyAccount"),
      path: user?.id ? "/settings/my-account/" : "/auth",
      mobileOnly: true
    }, {
      key: "my-wallet",
      label: t("MyWallet"),
      path: user?.id ? "/settings/my-wallet/" : "/auth",
      mobileOnly: true
    }, {
      key: "my-purchases",
      label: t("MyPurchases"),
      path: user?.id ? "/settings/my-purchases/" : "/auth",
      mobileOnly: true
    }];
    const isActive = path => {
      const stripLocale = _temp2;
      const normalize = _temp3;
      const cur = normalize(stripLocale(pathname));
      const target = normalize(path);
      if (target === "/") {
        return cur === "/";
      }
      return cur === target || cur.startsWith(`${target}/`);
    };
    t6 = <nav className="hidden items-center justify-center gap-14 lg:flex">{navItems.filter(_temp4).map(item_0 => {
        const active = isActive(item_0.path);
        return <Link key={item_0.key} href={`/${locale}/${item_0.path}`} className={cn("relative font-montserrat text-[16px] font-semibold uppercase text-white transition-colors hover:text-[#0A84FF]")}>{item_0.label}{active && <div className="absolute -bottom-[16px] left-0 right-0 h-[3px] bg-gradient-to-r from-[#FF4D00] to-[#FF8000]" />}</Link>;
      })}</nav>;
    t3 = mobileMenuVisible;
    t4 = "flex w-full flex-col lg:hidden";
    t5 = <div className="mb-8 flex flex-col px-4">{navItems.slice(0, 4).map((item_1, index) => {
        const active_0 = isActive(item_1.path);
        return <div key={item_1.key} className="w-full"><FastNavLink href={item_1.path} onBeforeNavigate={() => setIsMobileMenuOpen?.(false)} className="flex w-full items-center justify-start py-[11px] text-left"><span className={cn("font-montserrat text-[16px] font-semibold uppercase text-white", active_0 && "text-[#00BFFF]")}>{item_1.label}</span>{active_0 && <div className="ml-2 h-0.5 w-4 bg-[#00BFFF]" />}</FastNavLink>{index < 3 && <div className="border-b border-[#2d2d2d]" />}</div>;
      })}</div>;
    t1 = "flex flex-col px-4";
    t2 = navItems.slice(4).map((item_2, index_0) => {
      const active_1 = isActive(item_2.path);
      return <div key={item_2.key} className="w-full"><FastNavLink href={`/${locale}/${item_2.path}`} onBeforeNavigate={() => setIsMobileMenuOpen?.(false)} className="flex w-full items-center justify-start py-[11px] text-left"><span className={cn("font-montserrat text-[16px] font-semibold uppercase text-white", active_1 && "text-[#00BFFF]")}>{item_2.label}</span>{active_1 && <div className="ml-2 h-0.5 w-4 bg-[#00BFFF]" />}</FastNavLink>{index_0 < 2 && <div className="border-b border-[#2d2d2d]" />}</div>;
    });
    $[0] = locale;
    $[1] = mobileMenuVisible;
    $[2] = pathname;
    $[3] = setIsMobileMenuOpen;
    $[4] = t;
    $[5] = user?.id;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t7) {
    t8 = <div data-mobile-menu-open={t3} className={t4}>{t5}{t7}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};

//---------------------------------
// Компонент навигации СТАРЫЙ
// const Navigation: FC<{
//   mobileMenuVisible: boolean;
//   onNavigate?: (path: string) => void;
//   setIsMobileMenuOpen?: (open: boolean) => void;
// }> = ({mobileMenuVisible, onNavigate: _onNavigate, setIsMobileMenuOpen}) => {
//   const t = useTranslations('HeaderV2.Navigation');
//   const pathname = usePathname();
//   const user = useUserStore(store => store.user);

//   const navItems = [
//     {key: 'market', label: t('Market'), path: `/auctions/`},
//     {key: 'actions', label: t('Actions'), path: `/earn/`},
//     {key: 'leaderboard', label: t('Leaderboard'), path: `/leaderboard/`},
//     {key: 'partners', label: t('Partners'), path: `/partners/`},
//     // { key: 'news', label: t('News'), path: `/news/` },
//     {key: 'my-account', label: t('MyAccount'), path: user?.id ? `/settings/my-account/` : '/auth', mobileOnly: true},
//     {key: 'my-wallet', label: t('MyWallet'), path: user?.id ? `/settings/my-wallet/` : '/auth', mobileOnly: true},
//     {
//       key: 'my-experiences',
//       label: t('MyExperiences'),
//       path: user?.id ? `/settings/my-experiences/` : '/auth',
//       mobileOnly: true,
//     },
//   ];

//   // Функция для определения активного элемента
//   const isActive = (path: string) => {
//     const stripLocale = (p: string) => p.replace(/^\/[a-z]{2}(?=\/|$)/i, '') || '/';
//     const normalize = (p: string) => {
//       let s = p.split('#')[0].split('?')[0];
//       if (!s.startsWith('/')) s = '/' + s;
//       if (s.length > 1 && s.endsWith('/')) s = s.slice(0, -1);
//       return s;
//     };

//     const cur = normalize(stripLocale(pathname));
//     const target = normalize(path);

//     if (target === '/') return cur === '/';
//     return cur === target || cur.startsWith(`${target}/`);
//   };

//   return (
//     <>
//       {/* Десктопная навигация */}
//       <nav className="hidden flex-row items-center justify-center gap-14 lg:flex">
//         {navItems
//           .filter(item => !item.mobileOnly)
//           .map(item => {
//             const active = isActive(item.path);
//             return (
//               <Link
//                 key={item.key}
//                 href={item.path}
//                 className={cn(
//                   'relative font-montserrat text-[16px] font-semibold uppercase text-white transition-colors hover:text-[#0A84FF]',
//                 )}
//               >
//                 {item.label}
//                 {active && (
//                   <div className="absolute -bottom-[16px] left-0 right-0 h-[3px] bg-gradient-to-r from-[#FF4D00] to-[#FF8000]" />
//                 )}
//               </Link>
//             );
//           })}
//       </nav>

//       {/* Мобильная навигация */}
//       <div data-mobile-menu-open={mobileMenuVisible} className="flex w-full flex-col lg:hidden">
//         <div className="mb-8 flex flex-col px-4">
//           {navItems.slice(0, 4).map((item, index) => {
//             const active = isActive(item.path);
//             return (
//               <div key={item.key} className="w-full">
//                 <Link
//                   onClick={() => setIsMobileMenuOpen?.(false)}
//                   href={item.path}
//                   className="flex w-full items-center justify-start py-[11px] text-left"
//                 >
//                   <span
//                     className={cn(
//                       'font-montserrat text-[16px] font-semibold uppercase text-white',
//                       active && 'text-[#00BFFF]',
//                     )}
//                   >
//                     {item.label}
//                   </span>
//                   {active && <div className="ml-2 h-0.5 w-4 bg-[#00BFFF]" />}
//                 </Link>
//                 {index < 3 && <div className="border-b border-[#2d2d2d]" />}
//               </div>
//             );
//           })}
//         </div>

//         {/* Разделитель */}
//         {/* <div className="my-4 h-0.5 bg-gradient-to-r from-transparent via-[#504a8c] to-transparent" /> */}

//         <div className="flex flex-col px-4">
//           {navItems.slice(4).map((item, index) => {
//             const active = isActive(item.path);
//             return (
//               <div key={item.key} className="w-full">
//                 <Link
//                   onClick={() => setIsMobileMenuOpen?.(false)}
//                   href={item.path}
//                   className="flex w-full items-center justify-start py-[11px] text-left"
//                 >
//                   <span
//                     className={cn(
//                       'font-montserrat text-[16px] font-semibold uppercase text-white',
//                       active && 'text-[#00BFFF]',
//                     )}
//                   >
//                     {item.label}
//                   </span>
//                   {active && <div className="ml-2 h-0.5 w-4 bg-[#00BFFF]" />}
//                 </Link>
//                 {index < 2 && <div className="border-b border-[#2d2d2d]" />}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </>
//   );
// };
function _temp(store) {
  return store.user;
}
function _temp2(p) {
  return p.replace(/^\/[a-z]{2}(?=\/|$)/i, "") || "/";
}
function _temp3(p_0) {
  let s = p_0.split("#")[0].split("?")[0];
  if (!s.startsWith("/")) {
    s = "/" + s;
  }
  if (s.length > 1 && s.endsWith("/")) {
    s = s.slice(0, -1);
  }
  return s;
}
function _temp4(item) {
  return !item.mobileOnly;
}